import React from "react";
import { useTranslation } from "react-i18next";
import { FEATURE_CARDS } from "../../constants/featureCards";
import { SECTION_CONTAINER } from "../../utils/layout";

const CARD_CLASS =
  "rounded-border corner-accent-card relative flex min-h-[220px] w-full max-w-sm flex-col overflow-hidden pb-5 sm:min-h-[230px] lg:max-w-[260px]";

function FeatureCards({ className = "" }) {
  const { t } = useTranslation();

  return (
    <div
      className={`${SECTION_CONTAINER} flex flex-col items-center gap-6 pt-12 sm:flex-row sm:flex-wrap sm:justify-center sm:pt-16 lg:gap-8 ${className}`}
    >
      {FEATURE_CARDS.map(({ icon, titleKey, descriptionKey }) => (
        <div key={titleKey} className={CARD_CLASS}>
          <div className="m-auto flex w-[85%] flex-col items-center justify-center text-center">
            <img src={icon} alt="" className="w-[50px]" loading="lazy" />
            <p className="mt-1 text-sm font-bold">{t(titleKey)}</p>
            <p className="mt-1 text-sm font-normal">{t(descriptionKey)}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FeatureCards;
